import React from "react";
import { Card, CardBody } from "reactstrap";
import InvoiceListOnlyFinals from "./InvoiceListOnlyFinals";
import { Person } from "models/Person";
import { Account } from "models/Account";
import { useAccountTranslation } from "../translations";
import { connect } from "react-redux";
import { RootStateAccount } from "storeAccount/accountStore";
import { InvoiceState } from "storeAccount/reducers/Invoices";
import InvoicePaymentFileButton from "./InvoicePaymentFileButton";

interface Props {
    person: Person;
    quotes: boolean;
    customer: Account | null;
    invoiceState: InvoiceState;
}

const AccountInvoiceList: React.FC<Props> = ({ customer, quotes, person, invoiceState }) => {
    const { t } = useAccountTranslation();

    if (customer === null) {
        return (
            <Card>
                <CardBody>
                    <div>
                        <p className="text-muted text-uppercase fw-semibold">{t("chooseCompany")}</p>
                    </div>
                </CardBody>
            </Card>
        )
    }

    return (
        <Card>
            <CardBody>
                {quotes
                    ? <p className="text-muted text-uppercase fw-semibold">{t("quotes")}</p>
                    : <InvoicePaymentFileButton
                        customer={customer}
                        invoices={invoiceState.getInvoicesByCustomerId(customer.id)}
                        title={t("invoices")}
                    />}
                <InvoiceListOnlyFinals customer={customer} quotes={quotes} person={person} />
            </CardBody>
        </Card>
    );
};

const mapStateToProps = (state: RootStateAccount) => ({
    invoiceState: state.Invoices,
});

export default connect(mapStateToProps)(AccountInvoiceList);
